module.exports = __webpack_public_path__ + "img/facilities_off.6cc1cda3.svg";